export default "__VITE_ASSET__BQ0HopS8__"